import {makePostConfirmPhone} from 'main/factories/usecases';

export async function postConfirmPhone(phone: string) {
	await makePostConfirmPhone().post({celular: phone});

	return phone;
}
